export default {
    welcomeTitle: "Välkommen till Bwell",
    introText: "Bwell ger dig som anställd en personlig Livsstilsplan och hjälper dig att bestämma hur du vill ha ditt fysiska, mentala och sociala liv framöver. Sånt som är viktigt för att kunna må bra!",
    formTitle: "Logga in",
    emailPlaceholder: "Din e-postadress",
    passwordPlaceholder: "Ditt lösenord",
    togglePasswordAriaLabel: "Visa/dölj lösenord",
    loading: "Loggar in...",
    ok: "OK",
    genericErrorTitle: "Ett fel uppstod",
    genericErrorMessage: "Något gick fel. Försök igen senare.",
    copyright: "© 2025 Bwell Academy. Alla rättigheter förbehållna."
  };